import useSWR from 'swr';
import { customSWRConfig, customSWRResponse, Organization } from '../model/types';
import { isValidNumberForRequest } from '../utils/validation';
import useSWRCacheKeys from './useSWRCacheKeys';

export default function useOrganizationInfo(
    organizationId: string,
    config: customSWRConfig = {}
): customSWRResponse<Organization> {
    const keys = useSWRCacheKeys(isValidNumberForRequest(organizationId) ? `/organizations/${organizationId}` : null);

    return useSWR<Organization>(keys, { ...config });
}
